/** Shopify CDN: Minification failed

Line 16:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 17:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 18:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 20:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 30:0 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 32:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 38:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 49:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 52:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 57:2 Transforming const to the configured target environment ("es5") is not supported yet
... and 16 more hidden warnings

**/

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const pxl = urlParams.get("pixelID");
if (pxl != "" || pxl) {
  sessionStorage.setItem("pixelID", pxl);
} else {
  console.log("no pixel id found");
}

const url = window.location.href;
console.log(url);
const LStorage = localStorage.getItem("MA-url");
const SStorage = sessionStorage.getItem("MA-url");

const postsent = sessionStorage.getItem("postsent");
if (postsent == "true") {
  sessionStorage.setItem("postsent", "false");
}

if (!SStorage) {
  sessionStorage.setItem("MA-url", url);
  localStorage.setItem("MA-url", url);
}

async function fetchCountry() {
  try {
    const response = await fetch(
      "https://dz5yc9ggwa4v9.cloudfront.net/Lambda/GetCountry"
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const country = await response.text();
    sessionStorage.setItem("country_code", country);
  } catch (error) {
    sessionStorage.setItem("country_code", "no_country");
    console.error("There was a problem with the fetch operation:", error);
  }
}

fetchCountry();

// Create a URL object
const urlObj = new URL(url);

// Extract specific parameters
const variant = urlObj.searchParams.get("variant");

if (variant !== null) {
  sessionStorage.setItem("variant", variant);
  sessionStorage.setItem("serviceid", getVariant(url).serviceid);
} else {
  const varia = getVariant(url);
  sessionStorage.setItem("variant", varia.Variant);
  sessionStorage.setItem("serviceid", varia.serviceid);
}

function getVariant(url) {
  const pathurl = new URL(url);
  const path = pathurl.pathname;
  let Variant = ""; // Initialize Variant variable
  let serviceid = "";
  const variantParam = pathurl.searchParams.get("variant");
  if (variantParam) {
    Variant = variantParam;
    switch (variantParam) {
      case "45892090560771":
        serviceid = 3796;
        break;
      case "45839242592515":
        serviceid = 3797;
        break;
      case "45839242625283":
        serviceid = 3798;
        break;

      case "50075111391563":
        serviceid = 3782;
        break;

      case "50258020663627":
        serviceid = 3796;
        break;
      case "50258020696395":
        serviceid = 3797;
        break;
      case "50258020729163":
        serviceid = 3798;
        break;

      case "50075111326027":
        serviceid = 3757;
        break;

      case "50022403866955":
        serviceid = 3399;
        break;

      case "50075111358795":
        serviceid = 3496;
        break;

      case "45454002749699":
        serviceid = 3757;
        break;

      case "45839247671555":
        serviceid = 3399;
        break;

      case "45839247704323":
        serviceid = 3496;
        break;
    }
  } else {
    switch (path) {
      case "/products/erevil-eu-premium-male-booster-pills-1":
        Variant = 50258020663627;
        serviceid = 3796;
        break;

      case "/products/erevil-eu-premium-male-booster-pills":
        Variant = 45892090560771;
        serviceid = 3796;
        break;

      case "/products/imuvil-immunity-booster-for-adults":
        Variant = 50075111326027;
        serviceid = 3757;
        break;

      case "/products/imuvil-immunity-food-supplement":
        Variant = 45454002749699;
        serviceid = 3757;
        break;

      default:
        // Handle cases where path doesn't match any expected product path
        Variant = 0000;
    }
  }

  return {
    Variant: Variant,
    serviceid: serviceid,
  };
}

// Intercept pushState and replaceState
(function (history) {
  const pushState = history.pushState;
  const replaceState = history.replaceState;

  history.replaceState = function (state) {
    const result = replaceState.apply(history, arguments);
    window.dispatchEvent(new Event("replacestate"));
    window.dispatchEvent(new Event("locationchange"));
    return result;
  };
})(window.history);

window.addEventListener("replacestate", () => {
  const DynamicVariant = getVariant(window.location.href);
  console.log("Dynamic Variant : ", DynamicVariant);
  sessionStorage.setItem("variant", DynamicVariant.Variant);
  sessionStorage.setItem("serviceid", DynamicVariant.serviceid);
});

// Wait for the DOM to fully load before attaching event listener
document.addEventListener("DOMContentLoaded", () => {
  const productButton = document.getElementById(
    "ProductSubmitButton-template--23547317780811__main"
  );

  if (productButton) {
    productButton.addEventListener("click", () => {
      console.log("hello click button");
      const landingSite = localStorage.getItem("MA-url") || "";
      const variant = sessionStorage.getItem("variant") || "";
      const serviceid = sessionStorage.getItem("serviceid") || "";
      const countryCode = sessionStorage.getItem("country_code") || "";

      console.log("Add to cart : ", landingSite);

      // After 5 seconds, send the request regardless of whether the values are empty or not
      fetch(
        "https://a17nnptbog.execute-api.eu-central-1.amazonaws.com/default/ShopifyWebhookNet?IDEvent=1007",
        {
          method: "POST",
          body: JSON.stringify({
            landing_site: landingSite,
            variant: variant,
            serviceid: serviceid,
            country_code: countryCode,
          }),
          mode: "no-cors",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.text())
        .then((data) => {
          console.log("API Sent to S@S , ", landingSite, variant, countryCode);
          sessionStorage.setItem("postsent", "true");
        });
    });
  } else {
    console.error("Button with specified ID not found.");
  }
});
